module.exports = "/static-assets/_next/static/images/img-ecbda742d6-d15d989690b6dc730c266eff54ee77bd.webp";